import React, { useEffect, useState } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AddButton from "../../../components/admin/usable/AddButton";
import toast from "react-hot-toast";
import { registerAdmin, updateAdmin } from "../../../api/admin/userApi";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import Switch, { switchClasses } from "@mui/joy/Switch";

const EditUser = ({ setAdminData, Page, Limit, setPageData, data }) => {
  const [open, setOpen] = useState(false);
  const [FormData, setFormData] = useState({
    id: "",
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
    isAdmin: 1,
    status: 1,
    createdAt: new Date().toISOString(),
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  useEffect(() => {
    setFormData({
      id: data.id,
      fullName: data.fullName,
      email: data.email,
      phoneNumber: data.phoneNumber,
      password: data.password,
      isAdmin: data.isAdmin,
      status: data.status,
      createdAt: data.createdAt,
    });
  }, [data]);
  const handleSubmit = () => {
    if (
      FormData.fullName === "" ||
      FormData.email === "" ||
      FormData.phoneNumber === "" ||
      FormData.password === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      updateAdmin(
        FormData,
        setFormData,
        setAdminData,
        Page,
        Limit,
        setPageData,
        setOpen
      );
    }
  };

  return (
    <>
      <EditButton
        onClick={() => {
          setOpen(true);
        }}
      />

      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ minWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            Edit Admin here
          </Typography>
          <div className="w-full px-5 space-y-5">
            <div>
              <label htmlFor="password" className="text-black/60 text-xs">
                Full Name <small>(Legal Name)</small>
              </label>
              <input
                type="text"
                placeholder="Enter your full name"
                className="border w-full px-3 py-3 rounded-md focus:outline-none"
                value={FormData.fullName}
                onChange={handleChange}
                id="fullName"
              />
            </div>
            <div className="relative">
              <label htmlFor="phoneNumber" className="text-black/60 text-xs">
                Phone Number
              </label>
              <input
                type="text"
                placeholder="Enter Phone Number"
                className="border w-full px-12 py-3 rounded-md focus:outline-none"
                value={FormData.phoneNumber}
                onChange={handleChange}
                id="phoneNumber"
              />
            </div>
            <div>
              <label htmlFor="password" className="text-black/60 text-xs">
                Email
              </label>
              <input
                type="text"
                placeholder="Enter your email address"
                className="border w-full px-3 py-3 rounded-md focus:outline-none"
                value={FormData.email}
                onChange={handleChange}
                id="email"
              />
            </div>
            <div>
              <label htmlFor="password" className="text-black/60 text-xs">
                Password
              </label>
              <input
                type="text"
                placeholder="Enter your password"
                className="border w-full px-3 py-3 rounded-md focus:outline-none"
                value={FormData.password}
                onChange={handleChange}
                id="password"
              />
            </div>
            <div>
              <label className="text-black/60 text-xs">Status</label>
              <div>
                <Switch
                  onChange={() => {
                    setFormData((prevData) => ({
                      ...prevData,
                      status: prevData.status === 1 ? 0 : 1,
                    }));
                  }}
                  checked={FormData.status === 1}
                  sx={(theme) => ({
                    "--Switch-thumbShadow": "0 3px 7px 0 rgba(0 0 0 / 0.12)",
                    "--Switch-thumbSize": "27px",
                    "--Switch-trackWidth": "51px",
                    "--Switch-trackHeight": "31px",
                    "--Switch-trackBackground":
                      theme.vars.palette.background.level3,
                    [`& .${switchClasses.thumb}`]: {
                      transition: "width 0.2s, left 0.2s",
                    },
                    "&:hover": {
                      "--Switch-trackBackground":
                        theme.vars.palette.background.level3,
                    },
                    "&:active": {
                      "--Switch-thumbWidth": "32px",
                    },
                    [`&.${switchClasses.checked}`]: {
                      "--Switch-trackBackground": "rgb(48 209 88)",
                      "&:hover": {
                        "--Switch-trackBackground": "rgb(48 209 88)",
                      },
                    },
                  })}
                />
              </div>
            </div>
            <div>
              <button
                onClick={handleSubmit}
                className="bg-[#153875] w-full py-3 rounded-lg text-white text-sm font-semibold scale-100 hover:scale-105 duration-300 active:scale-95"
              >
                Update Now
              </button>
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default EditUser;
